module.exports = __webpack_public_path__ + "static/group-5-794082d9eec5db2dd0f0b6570468cffa.svg";